import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Year from 'Components/UI/BehavioralFormElement/Text/Year';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';
import { ContextIndex } from './FieldList';
import { makeHideable } from '../Hideable';

import './index.css';
import withViewContext from './withViewContext';

class Input extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value },
      },
    } = props;

    this.state = {
      value,
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => {
        this.setState({ value: res.attributes.value }, () => {
          const {
            props: { name, onChange },
          } = this;
          onChange(name, res.attributes.value);
        });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  onChange(value) {
    const { name, onChange } = this.props;
    this.setState({ value }, onChange(name, value));
  }

  onBlur() {
    const { householdId, uploadValue, answerKey } = this.props;
    const { value } = this.state;
    const index = this.context;
    uploadValue(householdId, answerKey, {
      attributes: {
        value: value.toString(),
        index,
      },
    });
  }

  render() {
    const { name, placeholder } = this.props;
    const { value, isDone } = this.state;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <Year
          value={value}
          label={placeholder}
          onBlur={e => this.onBlur(e)}
          onChange={(n, v) => {
            this.onChange(v);
          }}
          name={name}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Input.defaultProps = {
  onChange: noop,
  apiResponse: { attributes: {} },
};

Input.contextType = ContextIndex;

const YearInput = withHousehold(withQuestionnaireFuncs(withViewContext(Input)));

export default makeHideable(YearInput);
